import { useCallback, useMemo } from "react";
import {
  useLocation,
  useNavigate,
  useParams as useRRParams,
  useSearchParams as useRRSearchParams,
} from "react-router-dom";

type NavigateOptions = { scroll?: boolean };

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  return useMemo(
    () => ({
      push: (href: string, _opts?: NavigateOptions) => navigate(href),
      replace: (href: string, _opts?: NavigateOptions) =>
        navigate(href, { replace: true }),
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => navigate(location.pathname + location.search, { replace: true }),
      prefetch: (_href: string) => Promise.resolve(),
    }),
    [navigate, location.pathname, location.search]
  );
}

export function usePathname(): string {
  return useLocation().pathname;
}

export function useSearchParams() {
  const [params] = useRRSearchParams();
  return params;
}

export function useParams<T extends Record<string, string | string[]> = Record<string, string>>() {
  return useRRParams() as unknown as T;
}

export function redirect(href: string): never {
  if (typeof window !== "undefined") {
    window.location.href = href;
  }
  throw new Error(`redirect(${href})`);
}

export function notFound(): never {
  throw new Error("notFound()");
}

export function useSelectedLayoutSegment() {
  return null;
}

export function useSelectedLayoutSegments() {
  return [] as string[];
}
